module.exports = __webpack_public_path__ + "img/63 (1).e5fd0f7d.png";